import React from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { CheckCircle, XCircle, Info, X } from 'lucide-react';
import { theme } from '../../theme';
import { cn } from '../../lib/utils';

interface ToastProps {
  message: string;
  type: 'success' | 'error' | 'info';
  onClose: () => void;
}

export const Toast: React.FC<ToastProps> = ({ message, type, onClose }) => {
  const styles = {
    success: theme.components.toast.success,
    error: theme.components.toast.error,
    info: theme.components.toast.info
  };

  const icons = {
    success: <CheckCircle className={theme.components.toast.successIcon} size={18} />,
    error: <XCircle className={theme.components.toast.errorIcon} size={18} />,
    info: <Info className={theme.components.toast.infoIcon} size={18} />
  };

  return (
    <motion.div
      initial={{ opacity: 0, x: 20, scale: 0.95 }}
      animate={{ opacity: 1, x: 0, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95, transition: { duration: 0.2 } }}
      className={`pointer-events-auto flex items-center gap-3 px-5 py-4 rounded-2xl border shadow-lg shadow-black/5 min-w-[320px] ${styles[type]}`}
    >
      {icons[type]}
      <p className="flex-1 text-sm font-bold">{message}</p>
      <button 
        onClick={onClose}
        className="p-1 hover:bg-black/5 rounded-full transition-colors"
      >
        <X size={14} />
      </button>
    </motion.div>
  );
};
